import React from 'react';
import { Play, ExternalLink, Calendar } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';

const MediaGallery = () => {
  const videos = [
    {
      title: 'Ceasefire Project Video 1',
      description: 'World Peace Movement - Ceasefire Project',
      year: '2024',
      platform: 'YouTube',
      url: 'https://www.youtube.com/watch?v=FfxsdixwQkc',
      videoId: 'FfxsdixwQkc'
    },
    {
      title: 'Ceasefire Project Video 2',
      description: 'World Peace Movement - Ceasefire Project',
      year: '2024',
      platform: 'YouTube',
      url: 'https://www.youtube.com/watch?v=RTf5iyQYT2Y',
      videoId: 'RTf5iyQYT2Y'
    },
    {
      title: 'Ceasefire Project Video 3',
      description: 'World Peace Movement - Ceasefire Project',
      year: '2024',
      platform: 'YouTube',
      url: 'https://www.youtube.com/watch?v=wgW0_a-yyMY',
      videoId: 'wgW0_a-yyMY'
    },
    {
      title: 'Ceasefire Project Video 4',
      description: 'World Peace Movement - Ceasefire Project',
      year: '2024',
      platform: 'YouTube',
      url: 'https://www.youtube.com/watch?v=CpRQuQaT7Nk',
      videoId: 'CpRQuQaT7Nk'
    },
    {
      title: 'Ceasefire Project Video 5',
      description: 'World Peace Movement - Ceasefire Project',
      year: '2024',
      platform: 'YouTube',
      url: 'https://www.youtube.com/watch?v=l1zUYIuLZHk',
      videoId: 'l1zUYIuLZHk'
    },
    {
      title: 'Ceasefire Project Video 6',
      description: 'World Peace Movement - Ceasefire Project',
      year: '2024',
      platform: 'YouTube',
      url: 'https://www.youtube.com/watch?v=vv910AVXqEk',
      videoId: 'vv910AVXqEk'
    },
    {
      title: 'Ceasefire Project Video 7',
      description: 'World Peace Movement - Ceasefire Project',
      year: '2024',
      platform: 'YouTube',
      url: 'https://www.youtube.com/watch?v=oEHfohI4_Og',
      videoId: 'oEHfohI4_Og'
    },
    {
      title: 'Ceasefire Project Video 8',
      description: 'World Peace Movement - Ceasefire Project',
      year: '2024',
      platform: 'YouTube',
      url: 'https://www.youtube.com/watch?v=djGKtNPQRXE',
      videoId: 'djGKtNPQRXE'
    },
    {
      title: 'Ceasefire Project Video 9',
      description: 'World Peace Movement - Ceasefire Project',
      year: '2024',
      platform: 'YouTube',
      url: 'https://www.youtube.com/watch?v=xmx2ozQRYW0',
      videoId: 'xmx2ozQRYW0'
    },
    {
      title: 'Ceasefire Project Video 10',
      description: 'World Peace Movement - Ceasefire Project',
      year: '2024',
      platform: 'YouTube',
      url: 'https://www.youtube.com/watch?v=nzPOad63hoY',
      videoId: 'nzPOad63hoY'
    }
  ];

  return (
    <section id="media" className="py-24 bg-gradient-to-b from-black to-[#0B1D2A] relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 mb-6 backdrop-blur-sm">
            <Play className="w-5 h-5 text-[#D4AF37]" />
            <span className="text-[#D4AF37] text-sm font-medium" style={{ fontFamily: 'Lato, sans-serif' }}>
              World Peace Now Movement
            </span>
          </div>
          <h2
            className="text-4xl sm:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Ceasefire <span className="text-[#D4AF37]">Project</span>
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto rounded-full mb-6" />
          <p
            className="text-lg text-white/70 max-w-2xl mx-auto"
            style={{ fontFamily: 'Lato, sans-serif' }}
          >
            Voices calling for peace, transformation, and a world that works for everyone.
          </p>
        </div>

        {/* Video Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {videos.map((video, index) => (
            <Card
              key={index}
              className="bg-[#0B1D2A]/60 border-[#D4AF37]/20 overflow-hidden hover:border-[#D4AF37] transition-all duration-300 hover:transform hover:scale-105 backdrop-blur-sm group"
            >
              <a
                href={video.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                {/* Video Thumbnail */}
                <div className="relative aspect-video overflow-hidden bg-[#0B1D2A]">
                  <img
                    src={`https://img.youtube.com/vi/${video.videoId}/maxresdefault.jpg`}
                    alt={video.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    onError={(e) => {
                      e.target.src = `https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`;
                    }}
                  />
                  {/* Play Overlay */}
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/60 transition-colors">
                    <div className="w-16 h-16 rounded-full bg-[#D4AF37] flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Play className="w-8 h-8 text-black fill-black ml-1" />
                    </div>
                  </div>
                </div>

                {/* Video Info */}
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <Badge className="bg-[#D4AF37]/10 text-[#D4AF37] border-[#D4AF37]/30 text-xs">
                      <Calendar className="w-3 h-3 mr-1" />
                      {video.year}
                    </Badge>
                    <Badge className="bg-white/5 text-white/70 border-white/10 text-xs">
                      {video.platform}
                    </Badge>
                  </div>
                  <h3
                    className="text-xl font-bold text-white mb-3 group-hover:text-[#D4AF37] transition-colors"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {video.title}
                  </h3>
                  <p
                    className="text-white/70 text-sm leading-relaxed mb-4"
                    style={{ fontFamily: 'Lato, sans-serif' }}
                  >
                    {video.description}
                  </p>
                  <div className="flex items-center gap-2 text-[#D4AF37] text-sm font-semibold">
                    Watch Video
                    <ExternalLink className="w-4 h-4" />
                  </div>
                </div>
              </a>
            </Card>
          ))}
        </div>

        {/* More Media CTA */}
        <div className="mt-16 text-center">
          <p
            className="text-white/70 mb-4"
            style={{ fontFamily: 'Lato, sans-serif' }}
          >
            More content coming soon. Subscribe to stay updated.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MediaGallery;
